import React, { useState } from "react";
import Swal from "sweetalert2";
import CCTransferService from "../../services/CCTransferService";
import SideBar from "../../components/Sidebar";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";

const CreditCardToBankTransfer = () => {
  const [loading, setLoading] = useState(false);
  const services = [
    {
      name: "Education Payment",
      service_type: "EDUCATION_PAYMENT",
      icon: "/assets/images/education-payment-icon.png",
    },
    {
      name: "Rent Payment",
      service_type: "RENT_PAYMENT",
      icon: "/assets/images/rent-payment-icon.png",
    },
  ];

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const redirectHandler = async (service_type) => {
    // Show SweetAlert loading with logo and message
    Swal.fire({
      title: "Redirecting...",
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    await delay(4000); // wait for 3 seconds

    try {
      const result = await CCTransferService.getRedirectURL(service_type);

      if (!result.success) {
        Swal.fire("Oops!", result.message, "error");
        return;
      }

      const responseData = result.data;

      if (responseData.status === "SUCCESS") {
        const data = responseData.data;
        Swal.close(); // Close the loading modal
        window.open(data.redirect_url, "_blank"); // Open in new tab
      } else {
        Swal.fire("Oops!", responseData.message, "error");
      }
    } catch (error) {
      Swal.fire(
        "Oops!",
        error.response?.data?.message || error.message,
        "error"
      );
    }
  };

  return (
    <div>
      {loading && <LoadingScreen />}

      <div className="container-fluid mt-3">
        <div className="row">
          {/* Sidebar */}
          <SideBar />

          {/* Main Content */}
          <div className="col-md-9 mb-3">
            <div className="card mb-4 shadow-sm">
              <div className="card-body">
                <h5 className="card-title">Credit Card to Bank Transfer</h5>
                <div className="row text-center">
                  <div className="d-flex justify-content-center my-4">
                    <div className="d-flex gap-3 flex-wrap justify-content-center">
                      {services.map((service, index) => (
                        <div
                          key={index}
                          className="border rounded p-3 text-center shadow-sm hover-effect"
                          style={{ width: "250px", cursor: "pointer" }}
                          onClick={() => {
                            redirectHandler(service.service_type);
                          }}
                        >
                          <img
                            src={service.icon}
                            alt={service.name}
                            className="mb-2"
                            width="80"
                          />
                          <div
                            className="fw-medium small"
                            style={{ fontSize: "16px", fontWeight: "500" }}
                          >
                            {service.name}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreditCardToBankTransfer;
